import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Overview from "./Ops.Electricity.Overview";

const Electricity = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/electricity"
      render={() => <Redirect to={`/snapscan/ops/electricity/overview`} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/electricity/overview"
      render={() => <Overview {...props} />}
    />
  </Switch>
);

export default Electricity;
